import * as React from 'react';
import { Paragraph1 } from '@cian/ui-kit';
import { ContentWrapper } from '../ContentWrapper';
import { LandingBlock } from '../LandingBlock';

export function Notes() {
  return (
    <LandingBlock>
      <ContentWrapper>
        <Paragraph1 color="gray20_100" as="p">
          *Лучшие условия означает лучшие кредитные условия среди приложений от&nbsp;банков-партнеров
          Циан.Ипотека.&nbsp;2&nbsp;минуты&nbsp;&mdash; это среднее время формирования предварительных предложений
          по&nbsp;ипотеке от&nbsp;банков-партнеров. Циан.Ипотека не&nbsp;является банком и&nbsp;не&nbsp;оказывает услуги
          по&nbsp;ипотечному кредитованию. Интерфейс и&nbsp;процентные ставки в&nbsp;рекламных материалах&nbsp;&mdash;
          пример использования сервиса, не&nbsp;являются публичной офертой. Услуга ипотечного кредитования
          и&nbsp;информация о&nbsp;персональных условиях ипотечного кредитования, определяющие фактическую стоимость
          ипотечного кредита для заемщика,&nbsp;&mdash; предоставляется банками партнерами: БАНК ВТБ (ПАО) лицензия
          ЦБ&nbsp;РФ &#8470;&nbsp;1000 от&nbsp;17.10.1990, БАНК ГПБ (АО) лицензия ЦБ&nbsp;РФ &#8470;&nbsp;354
          от&nbsp;23.01.1992, ПАО РОСБАНК лицензия ЦБ&nbsp;РФ &#8470;&nbsp;2272 от&nbsp;02.03.1993,
          АО&nbsp;&laquo;Райффайзенбанк&raquo; лицензия ЦБ&nbsp;РФ &#8470;&nbsp;3292 от&nbsp;10.06.1996, ПАО
          &laquo;Промсвязьбанк&raquo; лицензия ЦБ&nbsp;РФ &#8470;&nbsp;3251 от&nbsp;12.05.1995, ПАО
          &laquo;СОВКОМБАНК&raquo; лицензия ЦБ&nbsp;РФ &#8470;&nbsp;963 от&nbsp;27.11.1990, АО&nbsp;&laquo;БАНК
          БЖФ&raquo; лицензия ЦБ&nbsp;РФ &#8470;&nbsp;3138 от&nbsp;20.10.1994.
          <br />* &mdash; %&nbsp;одобрений по&nbsp;данным Циан.Ипотека, Место в&nbsp;топ 15&nbsp;ипотечных банков
          по&nbsp;данным отчета РусИпотека за&nbsp;март 2020
        </Paragraph1>
      </ContentWrapper>
    </LandingBlock>
  );
}
